import { get, post, upload, del } from '@api/request';

export const fetchEvidences = async (
  { litigationService },
  authenticationToken,
  { arbitrationID },
) => {
  const url = `${litigationService}/litigation/arbitration/${arbitrationID}/owneragentevidence`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export async function uploadEvidence(
  { litigationService },
  authenticationToken,
  { payload },
) {
  const url = `${litigationService}/litigation/arbitration/uploadowneragentevidence`;
  const { body } = await upload(authenticationToken, url, payload);
  return body;
}

export async function insertEvidence(
  { litigationService },
  authenticationToken,
  { arbitrationID, payload },
) {
  const url = `${litigationService}/litigation/arbitration/${arbitrationID}/owneragentevidence`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function deleteEvidence(
  { litigationService },
  authenticationToken,
  { arbitrationOAEvidenceID },
) {
  const url = `${litigationService}/litigation/arbitration/owneragentevidence/${arbitrationOAEvidenceID}`;
  const { body } = await del(authenticationToken, url);
  return body;
}
